import { Data } from "@react-google-maps/api";
import axios from "axios";

window.sbapi = "https://easyapicore.superduper.pk";
window.imagesapi = "http://admin.superduper.pk";

export const DepartmentApi = () => (dispatch) => {
  fetch(`${window.sbapi}/api/Department/DGSData?BusinessId=0000000001`)
    .then((res) => res.json())
    .then((json) => {
      dispatch({
        type: "get_department_data",
        data: json?.data,
      });
    });
};

export const BrandApi = () => (dispatch) => {
  fetch(`${window.sbapi}/api/product/getbrands?BusinessId=0000000001`)
    .then((res) => res.json())
    .then((json) => {
      dispatch({
        type: "get_Brand_data",
        data: json?.data,
      });
    });
};

let Limit = 50;
export const PoductsApi = (dep, grup, sbGroup, start, end, append = false) => {
  return async (dispatch, getState) => {
    try {
      const fromIndex = typeof start === "number" && start > 0 ? start : 1;
      const toIndex = typeof end === "number" && end > 0 ? end : fromIndex + 11;

      const res = await fetch(
        `${window.sbapi}/api/Product/ProductEcomData?DepartmentCode=${
          dep || ""
        }&GroupCode=${grup || ""}&SubGroupCode=${
          sbGroup || ""
        }&FromIndex=${fromIndex}&ToIndex=${toIndex}&BusinessId=0000000001`
      );
      const json = await res.json();
      const data = json?.data?.map((item) => ({ ...item, qty: 1 })) || [];

      const existing = getState().ReducerAllProducts || [];

      dispatch({
        type: "get_allproducts_data",
        data: append ? [...existing, ...data] : data,
      });

      return data.length;
    } catch (err) {
      console.error("Failed to fetch products:", err);
      dispatch({ type: "get_allproducts_data", data: [] });
      return 0;
    }
  };
};

export const fetchPromoProductsApi = () => (dispatch) => {
  fetch(`${window.sbapi}/api/Product/PromoProducts?BusinessId=0000000001`)
    .then((res) => res.json())
    .then((json) => {
      const data = json?.data;

      if (!data) {
        console.error("No data field in response JSON");
        return;
      }

      const promoProducts =
        data?.map((item) => {
          return { ...item, qty: 1 };
        }) || [];

      dispatch({
        type: "get_pomo_products_data",
        data: { promoProducts },
      });
    })
    .catch((error) => {
      console.error("Fetch error:", error);
    });
};

export const fetchNewProductsApi = () => (dispatch) => {
  fetch(`${window.sbapi}/api/Product/NewArrivalProducts?BusinessId=0000000001`)
    .then((res) => res.json())
    .then((json) => {
      const data = json?.data;

      if (!data) {
        console.error("No data field in response JSON");
        return;
      }

      const newArrivalProducts =
        data?.map((item) => {
          return { ...item, qty: 1 };
        }) || [];

      dispatch({
        type: "get_new_products_data",
        data: { newArrivalProducts },
      });
    })
    .catch((error) => {
      console.error("Fetch error:", error);
    });
};

export const AddToCart = (data) => (dispatch) => {
  dispatch({
    type: "add_to_cart",
    payload: data,
  });
};

export const SetQty = (data) => (dispatch) => {
  dispatch({
    type: "set_qty",
    payload: data,
  });
};

export const RemoveItem = (data) => (dispatch) => {
  dispatch({
    type: "remove_item",
    payload: data,
  });
};

export const ClearCart = () => (dispatch) => {
  dispatch({
    type: "clear_cart",
  });
};

export const VegpoductsApi = () => (dispatch) => {
  fetch(
    `${window.sbapi}/api/Product/ProductEcomData?DepartmentCode=0004&GroupCode=&SubGroupCode=&FromIndex=1&ToIndex=5&BusinessId=0000000001`
  )
    .then((res) => res.json())
    .then((json) => {
      const data = json.data.map((item) => {
        item.qty = 1;
        return { ...item };
      });
      dispatch({
        type: "get_vegproducts_data",
        data: data,
      });
    });
};

export const BrandPoductsApi = (code) => (dispatch) => {
  // console.log("@@@@@@@@@@@@@@@@@@@" + code)
  // let url =''
  // if(code=="more Data"){
  //     // url  === "all-data" ? `${window.sbapi}/api/product/ProductsByBrand?BrandCode=&FromIndex=1&ToIndex=20&BusinessId=0000000001` : `${window.sbapi}/api/product/ProductsByBrand?BrandCode=${code}&FromIndex=1&ToIndex=20&BusinessId=0000000001`

  // }else{

  let url =
    code === "all-data"
      ? `${window.sbapi}/api/product/ProductsByBrand?BrandCode=&FromIndex=1&ToIndex=2000&BusinessId=0000000001`
      : `${window.sbapi}/api/product/ProductsByBrand?BrandCode=${code}&FromIndex=1&ToIndex=2000&BusinessId=0000000001`;

  // }

  fetch(url)
    .then((res) => res.json())
    .then((json) => {
      const data = json.data.map((item) => {
        item.qty = 1;
        return { ...item };
      });
      dispatch({
        type: "get_brandproducts_data",
        data: data,
      });
    });
};

export const FiltrApi = (data) => (dispatch) => {
  dispatch({
    type: "FilterData",
    payload: data,
  });
};
export const setBrandInfo = (data) => (dispatch) => {
  dispatch({
    type: "BRAND_INFO",
    payload: data,
  });
};

export const variationData = (data) => (dispatch) => {
  dispatch({
    type: "variation-Data",
    payload: data,
  });
};

export const setItemData = (data) => (dispatch) => {
  if ("qty" in data != true) {
    data.qty = 1;
  }
  dispatch({
    type: "set-item-date",
    payload: data,
  });
};

export const ChangeName = (data) => (dispatch) => {
  dispatch({
    type: "change_name",
    payload: data,
  });
};

export const MoreData = (data) => (dispatch) => {
  dispatch({
    type: "more data",
    payload: data,
  });
};
const showData = () => {
  setTimeout(() => {
    Limit = Limit + 5;
    PoductsApi();
  }, 300);
};
window.addEventListener("scroll", () => {
  const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
  if (scrollTop + clientHeight >= scrollHeight) {
    // console.log(Limit)
    showData();
  }
});
